import React from "react";

const STYLE = {
  Bronze: "bg-amber-100 text-amber-900 border-amber-300",
  Silver: "bg-slate-100 text-slate-700 border-slate-300",
  Gold: "bg-yellow-100 text-yellow-800 border-yellow-400",
  Platinum: "bg-cyan-50 text-cyan-800 border-cyan-300",
  Diamond: "bg-violet-50 text-violet-800 border-violet-300",
};

export const TierChip = ({ tier, percent }) => (
  <span data-testid={`tier-chip-${tier || "none"}`}
    className={`inline-block text-xs px-2.5 py-1 rounded-full border ${STYLE[tier] || "bg-black/5 border-black/10 text-ink-soft"}`}>
    {tier || "—"}{percent > 0 ? ` · ${percent}%` : ""}
  </span>
);
